import request from '../utils/request';

// 平台代售商品 API
export const platformSalesProductApi = {
  // 分页查询平台代售商品列表
  // params: { page, size, orderId }
  getPlatformSalesProductList: (params) => request.get('/platform-sales-product', { params }),
  
  // 获取平台代售商品详情
  getPlatformSalesProductDetail: (id) => request.get(`/platform-sales-product/${id}`),
  
  // 创建平台代售商品
  createPlatformSalesProduct: (data) => request.post('/platform-sales-product', data),
  
  // 更新平台代售商品
  updatePlatformSalesProduct: (id, data) => request.put(`/platform-sales-product/${id}`, data),
  
  // 删除平台代售商品
  deletePlatformSalesProduct: (id) => request.delete(`/platform-sales-product/${id}`),
  
  // 根据订单ID查询商品列表
  getProductsByOrderId: (orderId) => request.get(`/platform-sales-product/order/${orderId}`)
};

